import { Directive, inject, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[workflowWrappedControlHost]',
    standalone: false,
})
export class WorkflowWrappedControlDirective {
    readonly viewContainerRef = inject(ViewContainerRef);
}
